// extracted by mini-css-extract-plugin
export default {"font-renta":"FormText_font-renta__EIqyU","formText":"FormText_formText__idBpy","title":"FormText_title__vK04N","text":"FormText_text__+DbBy"};